import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		notification_count: 0,
		account_switch_count: 0,
		new_sale_count: 0,
		logged_in_user: JSON.parse(localStorage.getItem('logged_in_user')),
		logged_in_user_location_id: JSON.parse(localStorage.getItem('logged_in_user_location_id')),
		notifications: null,
		latest_notification: null,
		fetching_data: false,
		cashdrawer_amount: 0
	},
	mutations: {
		switch_account(state){
			state.account_switch_count ++
		},
		new_sale(state){
			state.new_sale_count ++
		},
		new_drawer_entry(state){
			var activities =  JSON.parse(localStorage.getItem('drawer_activity'))
			var amount = 0.00
			for (var activity of activities){
				console.log(activity)
				if (activity.status === "in"){
					amount = amount + parseFloat(activity.amount)
					console.log(activity.amount,amount,typeof(activity.amount),"in")
				}
				else {
					amount = amount - parseFloat(activity.amount)
					console.log(activity.amount,amount,typeof(activity.amount),"out")
				}
			}
			state.cashdrawer_amount = amount
		},
		log_in_user(state,payload){
			state.logged_in_user = payload
			state.logged_in_user_location_id = JSON.parse(localStorage.getItem('logged_in_user_location_id'))
		},
		new_notification (state,payload){
			state.notification_count ++
			state.latest_notification = payload
			payload.timeStamp = moment()

			//store notifications in local storage
			var notifications = JSON.parse(localStorage.getItem('notifications'))
			if (notifications !== null){
				notifications.unshift(payload)
				localStorage.setItem('notifications',JSON.stringify(notifications))
			}
			else{
				notifications = []
				notifications.unshift(payload)
				localStorage.setItem('notifications',JSON.stringify(notifications))
			}
			state.notifications = notifications
		},
		clear_notifications(state){
			state.notification_count = 0
			state.notifications = []
		},
		fetching_data(state){
			state.fetching_data = true
		},
		done_fetching(state){
			state.fetching_data = false
		}
	},
	actions: {
	},
	modules: {
	}
})
